import { TagGroup } from '@ukpostbox/frontend-framework';
import { MailTagCollectionType } from './Types/MailTagTypes';
import { MapMailTags } from './MapMailTags';

function MailTagCollection(props: MailTagCollectionType) {
	return (
		<TagGroup>
			<MapMailTags {...props} />
		</TagGroup>
	);
}

export { MailTagCollection };
